import { render, staticRenderFns } from "./tsVideos.vue?vue&type=template&id=2c37e188&scoped=true&"
import script from "./tsVideos.vue?vue&type=script&lang=js&"
export * from "./tsVideos.vue?vue&type=script&lang=js&"
import style0 from "./tsVideos.vue?vue&type=style&index=0&id=2c37e188&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37e188",
  null
  
)

export default component.exports